import { Image, ImageProps } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

export const ImageWDefault = ({ src, defaultSrc, ...rest }: { src: string; defaultSrc: string } & ImageProps) => {
  const [imgSrc, setImgSrc] = useState(src);
  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  return <Image src={imgSrc} onError={() => setImgSrc(defaultSrc)} {...rest} />;
};
